export var LocationFilterKeys = {
    SELECT_ALL_SITES: 'shift_management_views_filters_Location_selectAllSites'
};
